import { render } from "./Consecutivos2.vue?vue&type=template&id=3305bbc6"
import script from "./Consecutivos2.vue?vue&type=script&lang=js"
export * from "./Consecutivos2.vue?vue&type=script&lang=js"

import "./Consecutivos2.vue?vue&type=style&index=0&id=3305bbc6&lang=css"
script.render = render

export default script